import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';

export function LaoHistory({ history }) {
  const rows = history || [];
  return (
    <Card>
      <CardHeader>
        <CardTitle>ผลย้อนหลัง</CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-auto">
        {rows.length === 0 ? (
          <p className="text-sm text-gray-500">ยังไม่มีผลรางวัล</p>
        ) : (
          <table className="min-w-full text-left text-sm">
            <thead>
              <tr className="border-b text-gray-500">
                <th className="px-2 py-2">งวด</th>
                <th className="px-2 py-2">6 ตัว</th>
                <th className="px-2 py-2">3 บน</th>
                <th className="px-2 py-2">2 บน</th>
                <th className="px-2 py-2">2 ล่าง</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={`${row.periodKey}-${row.roundNumber}`} className="border-b border-gray-100">
                  <td className="whitespace-nowrap px-2 py-2 text-gray-600">
                    {row.periodLabel}
                  </td>
                  <td className="px-2 py-2 font-mono text-lg font-black text-brand-red">
                    {row.derived?.six || row.result}
                  </td>
                  <td className="px-2 py-2 font-mono font-bold">{row.derived?.threeTop}</td>
                  <td className="px-2 py-2 font-mono font-bold">{row.derived?.twoTop}</td>
                  <td className="px-2 py-2 font-mono font-bold text-brand-gold">
                    {row.derived?.twoBottom}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CardContent>
    </Card>
  );
}
